import { useEffect, useState } from "react";
import { logError } from "repoV2/utils/common/error/error";
import { IAnalytics } from "../Analytics.interfaces";
import { fetchAnalyticsConfig } from "../Analytics.utils";

/**
 * Custom hook to fetch analytics configuration based on the provided host name.
 * @param {string} hostName - The host name for which analytics configuration is required.
 * @returns {Object} An object containing the analytics configuration.
 */
const useAnalyticsConfig = ({ hostName }: { hostName: string }) => {
    const [config, setConfig] = useState<IAnalytics.IConfig>({});

    useEffect(() => {
        fetchAnalyticsConfig({ hostName })
            .then(setConfig)
            .catch(error =>
                logError({
                    error,
                    occuredAt:
                        "repoV2/features/Common/Analytics/hooks/useAnalyticsConfig.ts",
                    when: "calling fetchAnalyticsConfig",
                })
            );
    }, []);

    return { config };
};

export default useAnalyticsConfig;
